import { ToastContainer, toast } from "react-custom-alert";
import "react-custom-alert/dist/index.css";

export const AppAlert = {
  info: (msg) => toast.info(msg),
  success: (msg) => toast.success(msg),
  warning: (msg) => toast.warning(msg),
  error: (msg) => toast.error(msg),
};

export const AppAlertContainer = () => (
  <ToastContainer floatingTime={5000} toastClassName="custom-toast"/>
);